import { Component, OnDestroy, Output, EventEmitter } from '@angular/core';

import { OutletCardComponent } from '../OutletCard/outlet-card.component';
import { OutletContactTabType } from '../../../TargetingShared/services/targeting-rhp-contexts.service';
import { TargetingResultModel } from '../../../../Discover/Targeting/models/targeting-result.model';


@Component({
    selector: 'agpr-affiliate-card',
    templateUrl: './affiliate-card.component.html',
    styleUrls: ['../../../TargetingShared/components/ResultCard/result-card.scss'],
    standalone: false
})
export class AffiliateCardComponent extends OutletCardComponent implements OnDestroy {

    @Output() showRhpTakeOver: EventEmitter<any> = new EventEmitter<any>();

    onCardClicked(entity: TargetingResultModel) {
        this.showRhpTakeOver.emit({outletId: entity.id, tab: OutletContactTabType.affiliates});
    }
}
